import React from "react";
import { ImCheckmark } from "react-icons/im";
import { FaFileAlt, FaSms, FaArrowRight } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";

function Mark() {
  const navigate = useNavigate();
  const data = useLocation().state;
  const handleClick = () => {
    navigate("/otp", { state: data });
  };

  return (
    <div className="min-h-screen bg-primary100 flex flex-col justify-center items-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Success Icon Section */}
        <div className="bg-primary100 px-8 py-12 text-center">
          <div className="relative">
            <div className="w-24 h-24 bg-white rounded-full flex justify-center items-center mx-auto mb-4 shadow-lg">
              <ImCheckmark className="text-primary100 text-3xl" />
            </div>
            {/* Animated rings */}
            <div className="absolute inset-0 flex justify-center items-center">
              <div className="w-32 h-32 border-2 border-white/30 rounded-full animate-ping"></div>
            </div>
            <div className="absolute inset-0 flex justify-center items-center">
              <div className="w-40 h-40 border-2 border-white/20 rounded-full animate-ping" style={{animationDelay: '0.5s'}}></div>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Verification Successful!</h1>
          <p className="text-blue-100 text-sm">
            Your file number has been verified successfully
          </p>
        </div>

        {/* Content Section */}
        <div className="px-8 py-8">
          {/* Status Cards */}
          <div className="space-y-4 mb-8">
            <div className="flex items-center space-x-4 p-4 bg-green-50 rounded-lg border border-green-200">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                <FaFileAlt className="text-green-600" />
              </div>
              <div>
                <h3 className="font-semibold text-green-800">File Number Verified</h3>
                <p className="text-sm text-green-600">Your medical record has been located</p>
              </div>
            </div>

            <div className="flex items-center space-x-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <FaSms className="text-blue-600" />
              </div>
              <div>
                <h3 className="font-semibold text-blue-800">OTP Sent</h3>
                <p className="text-sm text-blue-600">Check your phone or email for verification code</p>
              </div>
            </div>
          </div>

          {/* Next Steps */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h4 className="font-semibold text-gray-800 mb-2">Next Steps:</h4>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Check your phone or email for the OTP message</li>
              <li>• Enter the 4-digit verification code</li>
              <li>• Complete your account setup</li>
            </ul>
          </div>

          {/* Continue Button */}
          <button
            onClick={handleClick}
            className="w-full bg-primary100 text-white py-4 rounded-lg font-semibold text-lg hover:opacity-90 transform hover:scale-[1.02] transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2"
          >
            <span>Continue to OTP Verification</span>
            <FaArrowRight />
          </button>

          {/* Help Text */}
          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              Didn't receive the OTP? Check your spam folder or{" "}
              <span className="text-primary100 hover:underline cursor-pointer">contact support</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mark;
